// /**
//   * 日期选择触发
//   * */

//  export const handleSelect(e) {
//  //获取到的e的数据入下
//  // 0:Tue Jun 01 2021 08:00:00 GMT+0800 (中国标准时间) {}
//  // 1:Fri Jun 11 2021 08:00:00 GMT+0800 (中国标准时间) {}

//    let date = []
//    for (const i in e) {
//      date.push(this.gettime(e[i]))
//    }
//    console.log(date, 'handleSelect')
//  },

/**
 * 时间处理函数
 * */
import { Message } from 'element-ui';
import $ from 'jquery';
export const gettime = (data) => {
  data = new Date(data)
  let value = data.getFullYear() + '-' +
    checkTime(data.getMonth() + 1) + '-' +
    checkTime(data.getDate()) + ' ' +
    checkTime(data.getHours()) + ':' +
    checkTime(data.getMinutes()) + ':' +
    checkTime(data.getSeconds());
  return value
}

/**
 * 时间处理
 * 如果时间小于10 ，则再前面加一个'0'
 * */

function checkTime(i) {
  if (i < 10) {
    i = "0" + i
  }
  return i;
}

//清空 空数组
export const delChilds = (item) => {
  if (!item.childs || !item.childs.length) {
    delete item.childs
    return
  }
  item.childs.forEach(item2 => {
    delChilds(item2)
  })
}


  //下载方法
  export const downloadFun = async (apiFun,params)=>{
  try {
      let res =  await apiFun(params)
      if (res.meta.status == 10000) {
        Message({
          showClose: true,
          message: '下载成功！',
          type: 'success',
          duration: 2000
        });
        if (res.data.url) {
          var a = document.createElement("a");
          a.href = res.data.url;
          $("body").append(a);
          a.click();
          $(a).remove();
        }
      } else {
        Message({
          showClose: true,
          message: '下载失败',
          type: 'error',
          duration: 2000
        });
      }
  } catch (error) {
    Message({
      showClose: true,
      message: '下载失败',
      type: 'error',
      duration: 2000
    });
  }

}



// WEBPACK FOOTER //
// ./src/utils/utils.js